export const INVOICES = [
    {
        "id": 1,
        "customer": "Customer 1",
        "invoice_date": "2025-07-03",
        "total": 500.00,
    },
    {
        "id": 2,
        "customer": "Customer 2",
        "invoice_date": "2025-07-10",
        "total": 100.00,
    }
]

export const INVOICE_FIELDS = [
    { 
      name: 'customer',
      label: 'Customer',
      type: 'text',
      rules: [{ required: true, message: 'Please input the Customer!' }]
    },
    { 
      name: 'description',
      label: 'Description',
      type: 'text',
      rules: [{ required: true, message: 'Please input the Description!' }]
    },
    {
      name: 'invoice_date',
      label: 'Invoice Date',
      type: 'date',
      rules: [{ required: true, message: 'Please select the Start Date!' }],
    },
    { 
      name: 'total',
      label: 'Total',
      type: 'number',
      rules: [{ required: true, message: 'Please input the Price!' }
    ]},
];

export const DEFAULT_SERVER_STATUS = {success: false, code: null, message: null};